// extracted by mini-css-extract-plugin
export var createdDate = "_gh-1";
export var divider = "_gh-2";
export var headerDivider = "_gh-3";
export var messagesCard = "_gh-0";
export var messagesContainer = "_gh-6";
export var messagesContainerWrapper = "_gh-4";
export var showLeftPanelButton = "_gh-8";
export var topButtons = "_gh-7";
export var withPadding = "_gh-5";